import { render, staticRenderFns } from "./RecentDocs.vue?vue&type=template&id=4804951e&scoped=true&"
import script from "./RecentDocs.vue?vue&type=script&lang=js&"
export * from "./RecentDocs.vue?vue&type=script&lang=js&"
import style0 from "./RecentDocs.vue?vue&type=style&index=0&id=4804951e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804951e",
  null
  
)

export default component.exports